const siteHeader = document.querySelector(".site-header");
const mobileBtn = document.querySelector(".site-header__mobile-btn");
const closeBtn = document.querySelector(".site-header__close-btn");
const mainMenu = document.querySelector(".site-header__navigation");
const parentMenuItems = document.querySelectorAll(
  ".site-header .main-nav .menu-item-has-children",
);
const pageInner = document.querySelector(".page-template-default .page__inner");
const blocksInContent = document.querySelectorAll(
  ".page-template-default .page__main .block[data-extract]",
);

const accordionItems = document.querySelectorAll(".accordion:not(.disabled)");

//Breakpoints
const mobile = 480;
const tablet = 768;
const ldpi = 1024;
const mdpi = 1200;
const hdpi = 1440;
// Shared with the block scripts, which run as separate files
window.themeBreakpoints = { mobile, tablet, ldpi, mdpi, hdpi };

requestAnimationFrame(() => {
  findConsecutiveGroups();
});

blocksInContent && extractBlocks();

document.addEventListener("DOMContentLoaded", () => {
  showMenus();
  footerOfficesSelector();
  eventListeners();

  document.querySelectorAll(".sidebar").forEach((el) => {
    if (!el.querySelector("*")) el.classList.add("is-empty");
  });
});

function eventListeners() {
  if (closeBtn) {
    closeBtn.addEventListener("click", closeMenu);
  }

  // Debounce resize event
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      showMenus();
    }, 250);
  });

  if (document.querySelector(".site-header--sticky"))
    window.addEventListener("scroll", fadeInHeader);

  accordionItems.forEach((item) => {
    const heading = item.querySelector(".accordion__heading");
    if (!heading) return;
    heading.setAttribute("aria-expanded", item.classList.contains("open") ? "true" : "false");
    heading.addEventListener("click", toggleAccordion);
  });

  // Elements that act as buttons without being one (accordion headings, icon buttons) respond to Enter and Space
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Enter" && e.key !== " ") return;
    const target = e.target;
    if (!(target instanceof Element) || !target.matches('[role="button"]:not(button):not(a)')) return;
    e.preventDefault();
    target.click();
  });

  // Escape closes the mobile menu and gives the focus back to its button
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape" || !mainMenu || !mainMenu.classList.contains("active")) return;
    closeMenu();
    mobileBtn && mobileBtn.focus();
  });
}

function showMenus() {
  // re-query in case the DOM changed
  const parentMenuItems = document.querySelectorAll(
    ".site-header .main-nav .menu-item-has-children",
  );

  if (!mobileBtn || !mainMenu) return;

  // always remove listener using the same reference before adding
  mobileBtn.removeEventListener("click", openMenu);

  // Viewport width, as in the CSS media queries (screen.width is the monitor width)
  if (window.innerWidth > mdpi) {
    mobileBtn.classList.remove("active");
    mainMenu.classList.remove("active");
    mobileBtn.setAttribute("aria-expanded", "false");

    // remove listeners on desktop
    parentMenuItems.forEach((item) => {
      item.removeEventListener("click", handleSubMenuClick);
      item.classList.remove("active");
    });
  } else {
    // add listener on mobile (same reference, no wrapper)
    mobileBtn.addEventListener("click", openMenu);
    if (!mobileBtn.hasAttribute("aria-expanded")) mobileBtn.setAttribute("aria-expanded", "false");

    parentMenuItems.forEach((item) => {
      // ensure there are no duplicates
      item.removeEventListener("click", handleSubMenuClick);
      item.addEventListener("click", handleSubMenuClick);
    });
  }
}

// Function to handle close button clicks
function closeMenu() {
  mainMenu.classList.remove("active");
  mobileBtn.classList.remove("active");
  mobileBtn.setAttribute("aria-expanded", "false");
}

// Function to handle menu item clicks
function openMenu() {
  removeSubmenuActiveClasses();
  const isOpen = mainMenu.classList.toggle("active");
  mobileBtn.classList.toggle("active", isOpen);
  mobileBtn.setAttribute("aria-expanded", isOpen ? "true" : "false");
}

// Function to handle submenu item clicks
function handleSubMenuClick(e) {
  // Links (and the spans inside them) navigate; anything else in the item toggles its submenu
  if (!e.target.closest("a")) {
    e.stopPropagation();
    let currentItem = e.currentTarget;
    currentItem.classList.toggle("active");
  }
}

function removeSubmenuActiveClasses() {
  parentMenuItems.forEach((item) => {
    item.classList.remove("active");
  });
}

//Top Bar on Scroll
function fadeInHeader() {
  if (window.scrollY > 0) {
    siteHeader.classList.add("scrolling");
  } else {
    siteHeader.classList.remove("scrolling");
  }
}

//Blocks
function extractBlocks() {
  if (!pageInner) return;

  // Move the block nodes (copying their HTML would drop listeners and state already attached to them)
  blocksInContent.forEach((item) => {
    pageInner.insertAdjacentElement(
      item.getAttribute("data-extract") === "before" ? "beforebegin" : "afterend",
      item,
    );
  });
}

//Find Blocks with Bg-gradient class
function findConsecutiveGroups() {
  // Top-level blocks, whether the template prints them in <body> or inside <main>
  const blocks = document.querySelectorAll("body>.block, body>main>.block");

  if (!blocks.length) return;

  const groups = [];
  let currentGroup = [];

  for (let i = 0; i < blocks.length; i++) {
    // Blocks with different parents are not consecutive siblings
    if (currentGroup.length && blocks[i].parentElement !== currentGroup[0].parentElement) {
      if (currentGroup.length > 1) groups.push([...currentGroup]);
      currentGroup = [];
    }

    if (blocks[i].classList.contains("bg-gradient")) {
      currentGroup.push(blocks[i]);
    } else {
      // Non-bg-gradient element breaks the sequence
      if (currentGroup.length > 1) {
        groups.push([...currentGroup]);
      }
      currentGroup = []; // Reset for next potential group
    }
  }

  if (currentGroup.length > 1) {
    groups.push(currentGroup);
  }

  groups.forEach((group) => {
    const firstEl = group[0];
    const wrapper = document.createElement("section");
    wrapper.classList.add("bg-gradient");

    firstEl.parentNode.insertBefore(wrapper, firstEl);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          wrapper.appendChild(entry.target);
          observer.unobserve(entry.target);

          // Once moved, if the wrapper already holds the rest of the elements, deferred loading can be triggered.
          if (wrapper.children.length === group.length) {
            lazyLoadBgGradient();
          }
        });
      },
      { rootMargin: "100px" },
    );

    group.forEach((el) => {
      observer.observe(el);
    });
  });

  // Always execute lazy load for:
  // - Non-consecutive bg-gradient sections
  // - Groups that haven't entered viewport yet
  lazyLoadBgGradient();
}

// Lazy Load Background Images for .bg-gradient
function lazyLoadBgGradient() {
  "use strict";

  const bgGradientElements = Array.from(
    document.querySelectorAll(".bg-gradient"),
  ).filter((el) => !el.parentElement?.closest(".bg-gradient"));

  if (!bgGradientElements.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("bg-gradient--loaded");
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: "100px" },
  );

  const init = () => bgGradientElements.forEach((el) => observer.observe(el));

  // If load has already fired (deferred script), init right away
  if (document.readyState === "complete") {
    init();
  } else {
    window.addEventListener("load", init, { once: true });
  }
}

//Accordion Items
function toggleAccordion(e) {
  const header = e.currentTarget;

  // Only clicks on the heading itself toggle the item; clicks on its text or on links inside it keep their default behavior
  if (e.target !== header) return;

  const content = header.nextElementSibling;
  const inner = content.querySelector(".accordion__inner");

  const isOpen = header.closest(".accordion").classList.toggle("open");
  header.setAttribute("aria-expanded", isOpen ? "true" : "false");

  // Open with the real content height, close by removing the inline max-height
  content.style.maxHeight = isOpen ? inner.scrollHeight + "px" : null;
}

//Footer Offices Selector
function footerOfficesSelector() {
  const officeSelectors = document.querySelectorAll(
    ".footer-offices-selector__item",
  );
  const offices = document.querySelectorAll(".footer-office");

  if (!officeSelectors.length || !offices.length) return;

  // The selected office is marked with the active class and, for assistive technology, aria-pressed on its button
  const setSelected = (selector, selected) => {
    selector.classList.toggle("active", selected);
    selector.querySelector("button")?.setAttribute("aria-pressed", selected ? "true" : "false");
  };

  // Set first element as active on page load
  officeSelectors.forEach((selector, index) => setSelected(selector, index === 0));
  if (offices[0]) {
    offices[0].classList.add("active");
  }

  officeSelectors.forEach((selector) => {
    selector.addEventListener("click", (e) => {
      const officeCity = selector.getAttribute("data-office");

      // Remove active class from all selectors and offices
      officeSelectors.forEach((item) => setSelected(item, false));
      offices.forEach((office) => office.classList.remove("active"));

      // Add active class to clicked selector
      setSelected(selector, true);

      // Add active class to matching office
      offices.forEach((office) => {
        if (office.getAttribute("data-office") === officeCity) {
          office.classList.add("active");
        }
      });
    });
  });
}

//Delay Google Maps Rendering
(function googleMapsLazyLoading() {
  "use strict";

  const embeddedMaps = document.querySelectorAll(".gmap-lazy");
  if (!embeddedMaps.length) return;

  let pageLoaded = false;
  const loadedMaps = new WeakSet();

  window.addEventListener("load", () => {
    pageLoaded = true;
    initMaps();
  });

  function initMaps() {
    embeddedMaps.forEach((map) => {
      observer.observe(map);
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && pageLoaded) {
          loadEmbeddedMaps(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: "100px",
    },
  );

  function loadEmbeddedMaps(container) {
    // CRITICAL: Check and mark as loaded IMMEDIATELY
    if (loadedMaps.has(container)) return;
    loadedMaps.add(container);

    const src = container.dataset.src;
    if (!src) return;

    const iframe = document.createElement("iframe");
    iframe.src = src;
    iframe.width = "100%";
    iframe.height = "100%";
    iframe.style.cssText = `
      border: 0;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      transition: opacity 0.3s ease;
    `;
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = "no-referrer-when-downgrade";
    iframe.loading = "eager";

    container.innerHTML = "";
    container.appendChild(iframe);

    iframe.onload = () => {
      iframe.style.opacity = "1";
    };

    setTimeout(() => {
      iframe.style.opacity = "1";
    }, 300);
  }
})();

//Unwrap Elements
// wpautop wraps media of the content in paragraphs; move them out. Only media that are direct children of paragraphs
// in the main content are moved, so linked images keep their link and the header/footer are left alone.
window.addEventListener("load", () => {
  const wrappedImages = document.querySelectorAll(
    "main p:has(> img, > picture, > figure)",
  );
  wrappedImages.forEach((paragraph) => {
    const elementsToUnwrap = paragraph.querySelectorAll(":scope > img, :scope > picture, :scope > figure");
    elementsToUnwrap.forEach((element) => {
      paragraph.insertAdjacentElement("beforebegin", element);
    });
    if (paragraph.textContent.trim() === "") {
      paragraph.remove();
    }
  });
});

// Observe Section Visibility
(function observeSectionVisibility() {
  "use strict";

  const sections = document.querySelectorAll("section");

  if (!sections.length) return;

  const visibilityObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          !entry.target.hasAttribute("data-visible")
        ) {
          entry.target.setAttribute("data-visible", "true");
        }
        // Do not remove the attribute when exiting
      });
    },
    { rootMargin: "0px", threshold: 0.1 }, // Adjust threshold as needed
  );

  const initVisibility = () => {
    sections.forEach((section) => visibilityObserver.observe(section));
  };

  if (document.readyState === "complete") {
    initVisibility();
  } else {
    window.addEventListener("load", initVisibility, { once: true });
  }
})();

// Playback Video
(function () {
  // ─── Source detection ────────────────────────────────────────────────────────

  function isLocalVideo(videoId) {
    if (!videoId) return false;
    if (videoId.startsWith(`${siteData["homeURL"]}/wp-content/`)) return true;
    try {
      return (
        new URL(videoId, window.location.href).hostname ===
        window.location.hostname
      );
    } catch {
      return false;
    }
  }

  // Returns the 11-character ID of a single YouTube video, or null for URLs that are not a video
  // (channels, playlists, search results, the homepage...). Mirrors get_yt_code() in helpers.php
  function extractYouTubeID(url) {
    let value = String(url || "").trim();
    if (!value) return null;
    if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(value)) value = "https://" + value.replace(/^\/+/, "");

    let parsed;
    try {
      parsed = new URL(value);
    } catch (e) {
      return null;
    }

    const host = parsed.hostname.toLowerCase().replace(/^(www\.|m\.|music\.)/, "");
    const segments = parsed.pathname.split("/").filter(Boolean);
    let id = null;

    if (host === "youtu.be") {
      id = segments[0];
    } else if (host === "youtube.com" || host === "youtube-nocookie.com") {
      if (segments[0] === "watch") {
        id = parsed.searchParams.get("v");
      } else if (["embed", "shorts", "live", "v", "e"].includes(segments[0])) {
        id = segments[1];
      }
    }

    // "videoseries" is the 11-character placeholder used by playlist embeds, not a video
    return id && id !== "videoseries" && /^[A-Za-z0-9_-]{11}$/.test(id) ? id : null;
  }

  function detectSource(trigger, rawValue) {
    if (isLocalVideo(rawValue)) return "local";
    if (trigger.classList.contains("ig-video")) return "instagram";
    if (extractYouTubeID(rawValue)) return "youtube";
    return "unknown";
  }

  // ─── Video ID resolution ─────────────────────────────────────────────────────
  // Accepts both data-videourl (full URL) and data-videoid (plain ID)

  function resolveVideoId(trigger, source) {
    const raw = trigger.dataset.videourl || trigger.dataset.videoid || "";
    if (source === "youtube") return extractYouTubeID(raw) || raw;
    return raw;
  }

  // ─── Player builders ─────────────────────────────────────────────────────────

  function buildIframe(attrs) {
    const attrStr = Object.entries(attrs)
      .map(([k, v]) => (v === true ? k : `${k}="${v}"`))
      .join(" ");
    return `<iframe ${attrStr}></iframe>`;
  }

  function buildPlayer(source, videoId, autoplay = false) {
    switch (source) {
      case "youtube":
        return buildIframe({
          src: `https://www.youtube.com/embed/${videoId}?enablejsapi=1&rel=0&autoplay=${autoplay ? 1 : 0}`,
          title: "YouTube video player",
          frameborder: "0",
          allow:
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
          allowfullscreen: true,
        });

      case "instagram":
        return buildIframe({
          class: "instagram-media instagram-media-rendered",
          src: `https://www.instagram.com/reel/${videoId}/embed/?cr=1&v=14&wp=1080`,
          allowtransparency: "true",
          allowfullscreen: true,
          frameborder: "0",
          scrolling: "no",
          style: [
            "background:white",
            "max-width:540px",
            "width:calc(100% - 2px)",
            "border-radius:3px",
            "border:1px solid rgb(219,219,219)",
            "display:block",
            "margin:0 0 12px",
            "min-width:326px",
            "padding:0",
          ].join(";"),
        });

      case "local": {
        const type = videoMimeType(videoId);
        return `<video controls ${autoplay ? "autoplay" : ""} playsinline>
                  <source src="${videoId}"${type ? ` type="${type}"` : ""}>
                </video>`;
      }

      default:
        console.warn("[VideoPlayer] Unrecognized video source:", videoId);
        return "";
    }
  }

  // MIME type of a local video from its extension; unknown formats are left for the browser to sniff
  function videoMimeType(url) {
    const extension = (String(url).split(/[?#]/)[0].match(/\.([a-z0-9]+)$/i) || [])[1];
    const types = { mp4: "video/mp4", m4v: "video/mp4", webm: "video/webm", ogv: "video/ogg", ogg: "video/ogg", mov: "video/quicktime" };
    return types[(extension || "").toLowerCase()] || "";
  }

  // ─── Lightbox mode ───────────────────────────────────────────────────────────

  const i18n = (window.siteData && window.siteData.i18n) || {};
  let activeOverlay = null;
  let focusBeforeOverlay = null;

  function openLightbox(source, videoId) {
    if (activeOverlay) return;

    document.body.insertAdjacentHTML(
      "afterbegin",
      `<div id="video-overlay" class="${source === "instagram" ? "ig-video" : ""}" role="dialog" aria-modal="true" aria-label="${i18n.videoDialog || "Video player"}">
        <button class="overlay-close" aria-label="${i18n.closeVideo || "Close video"}">✕</button>
        <div class="video-container">
          ${buildPlayer(source, videoId, true)}
        </div>
      </div>`,
    );

    const overlay = document.body.firstElementChild;
    const container = overlay.querySelector(".video-container");
    const iframe = overlay.querySelector("iframe");
    const closeButton = overlay.querySelector(".overlay-close");
    activeOverlay = overlay;

    closeButton.addEventListener("click", closeOverlay);
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) closeOverlay();
    });
    document.addEventListener("keydown", handleKeydown);

    // Move the focus into the dialog and give it back to the trigger on close
    focusBeforeOverlay = document.activeElement;
    closeButton.focus({ preventScroll: true });

    // Trigger the transition: display:flex needs one frame for the transition to work
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        overlay.classList.add("active");
        container.classList.add("active");

        // Deferred autoplay: wait until the iframe is rendered
        if (iframe && source === "youtube") {
          iframe.addEventListener(
            "load",
            () => {
              iframe.src = iframe.src.replace("autoplay=0", "autoplay=1");
            },
            { once: true },
          );
        }
      }),
    );
  }

  function closeOverlay() {
    const overlay = activeOverlay;
    if (!overlay) return;
    activeOverlay = null;

    const container = overlay.querySelector(".video-container");
    const iframe = overlay.querySelector("iframe");
    const video = overlay.querySelector("video");

    if (iframe) iframe.src = "";
    if (video) video.pause();

    overlay.classList.remove("active");
    container.classList.remove("active");
    document.removeEventListener("keydown", handleKeydown);

    // The overlay fades out for 500ms: let clicks go through it meanwhile
    overlay.style.pointerEvents = "none";
    setTimeout(() => overlay.remove(), 500);

    if (focusBeforeOverlay && document.contains(focusBeforeOverlay)) {
      focusBeforeOverlay.focus({ preventScroll: true });
    }
    focusBeforeOverlay = null;
  }

  function handleKeydown(e) {
    if (e.key === "Escape") {
      closeOverlay();
      return;
    }

    // Keep the keyboard focus inside the dialog
    if (e.key === "Tab" && activeOverlay) {
      const focusable = Array.from(activeOverlay.querySelectorAll("button, iframe, video"));
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (!activeOverlay.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  // ─── Inline mode ─────────────────────────────────────────────────────────────

  function openInline(trigger, source, videoId) {
    // Look for the target inside the trigger's own block first, so several video blocks on a page don't clash
    const target = trigger.dataset.target;
    const container = target
      ? trigger.closest(".featured-video")?.querySelector(target) ||
        document.querySelector(target)
      : null;

    if (!container) {
      console.warn(
        "[VideoPlayer] Inline container not found. Fallback to lightbox.",
      );
      openLightbox(source, videoId);
      return;
    }

    const prevIframe = container.querySelector("iframe");
    const prevVideo = container.querySelector("video");
    if (prevIframe) prevIframe.src = "";
    if (prevVideo) prevVideo.pause();

    container.innerHTML = buildPlayer(source, videoId, true);
    container.classList.add("active");
    container.scrollIntoView({ behavior: "smooth", block: "nearest" });

    // The play button was replaced by the player, so move focus to it instead of losing it
    const player = container.querySelector("iframe, video");
    if (player) player.focus({ preventScroll: true });
  }

  // ─── Init ────────────────────────────────────────────────────────────────────

  function init() {
    // Event delegation — covers static and dynamic buttons (AJAX, Gutenberg, etc.)
    document.addEventListener("click", (e) => {
      const trigger = e.target.closest("[data-videourl], [data-videoid]");
      if (!trigger) return;

      e.preventDefault();

      const raw = (
        trigger.dataset.videourl ||
        trigger.dataset.videoid ||
        ""
      ).trim();
      if (!raw) return;

      const source = detectSource(trigger, raw);
      const videoId = resolveVideoId(trigger, source);
      const mode = trigger.dataset.mode || "lightbox";

      mode === "inline"
        ? openInline(trigger, source, videoId)
        : openLightbox(source, videoId);
    });
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
})();

// Default Card Hover Effect
window.addEventListener("load", () => {
  const defaultCards = document.querySelectorAll(".default-card.content");
  if (!defaultCards.length) return;

  let cardController = null;

  cardController = toggleContent(defaultCards, cardController);

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      cardController = toggleContent(defaultCards, cardController);
    }, 250);
  });
});

function toggleContent(defaultCards, oldController) {
  if (oldController) {
    oldController.abort();
  }

  if (window.innerWidth >= 1024) {
    defaultCards.forEach((card) => card.classList.remove("show-content"));
    return null;
  }

  const newController = new AbortController();
  const signal = newController.signal;

  defaultCards.forEach((card) => {
    const con = card.querySelector(".default-card__con");

    card.addEventListener(
      "click",
      (e) => {
        if (con && con.contains(e.target)) return;

        e.preventDefault();
        card.classList.toggle("show-content");
      },
      { signal },
    );
  });

  return newController;
}
